export const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

export const parseJSON = (data, ...args) => {
	if (typeof data === 'string' && /^[\[{]/[Symbol.match](data)) {
		return JSON.parse(data, ...args);
	}
	return data;
};

export const getDateString = date => {
	if (['string', 'number'].includes(typeof date)) {
		date = new Date(date);
	}

	return date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, 0) + '-' + date.getDate().toString().padStart(2, 0);
}

export const getTimeDiff = (target, origin = new Date()) => {
	if (!target) return;

	if (typeof target === 'string') {
		target = new Date(target);
	}

	if (typeof origin === 'string') {
		origin = new Date(origin);
	}

	const timeDiff = Math.abs(origin.getTime() - target.getTime());
	const isBefore = origin.getTime() - target.getTime() > 0;

	if (timeDiff < 1000) {
		return '@{just now}';
	} else if (timeDiff < 60 * 1000) {
		const num = Math.floor(timeDiff / 1000);
		return `@{time.${num === 1 ? 'second' : 'seconds'} ${isBefore ? 'ago' : 'later'}:${num}}`
	} else if (timeDiff < 60 * 60 * 1000) {
		const num = Math.floor(timeDiff / (60 * 1000));
		return `@{time.${num === 1 ? 'minute' : 'minutes'} ${isBefore ? 'ago' : 'later'}:${num}}`
	} else if (timeDiff < 24 * 60 * 60 * 1000) {
		const num = Math.floor(timeDiff / (60 * 60 * 1000));
		return `@{time.${num === 1 ? 'hour' : 'hours'} ${isBefore ? 'ago' : 'later'}:${num}}`
	} else if (timeDiff < 7 * 24 * 60 * 60 * 1000) {
		const num = Math.floor(timeDiff / (24 * 60 * 60 * 1000));
		return `@{time.${num === 1 ? 'day' : 'days'} ${isBefore ? 'ago' : 'later'}:${num}}`
	} else if (timeDiff < 30 * 24 * 60 * 60 * 1000) {
		const num = Math.floor(timeDiff / (7 * 24 * 60 * 60 * 1000));
		return `@{time.${num === 1 ? 'week' : 'weeks'} ${isBefore ? 'ago' : 'later'}:${num}}`
	} else if (timeDiff < 365 * 30 * 24 * 60 * 60 * 1000) {
		const num = Math.floor(timeDiff / (30 * 24 * 60 * 60 * 1000));
		return `@{time.${num === 1 ? 'month' : 'months'} ${isBefore ? 'ago' : 'later'}:${num}}`
	} else {
		const num = Math.floor(timeDiff / (365 * 24 * 60 * 60 * 1000));
		return `@{time.${num === 1 ? 'year' : 'years'} ${isBefore ? 'ago' : 'later'}:${num}}`
	}
};

export const waitUntil = async condition => {
	let result;
	while (!(result = condition())) {
		await sleep(50);
	}
	return result;
}

export const logX = (...args) => {
	if (!['production'].includes(process.env.VUE_APP_MODE) || window.localStorage.getItem('debug')) {
		let title = 'LogX', color = 'red', messages, noStyle = false;
		if (args.length >= 3) {
			[title, color, ...messages] = args;
		} else if (args.length === 2) {
			[title, ...messages] = args;
		} else if (args.length === 1) {
			[...messages] = args;
			noStyle = true;
		}

		if (noStyle) {
			console.log(...messages.map(m => parseJSON(JSON.stringify(m))));
		} else {
			console.log(`%c${title}`, `background-color: ${color}; color: white; border-radius: 16rem; padding: 4px 8px;`, ...messages.map(m => parseJSON(JSON.stringify(m))));
		}
	}
}

export const save = (key, value) => {
	if (value === undefined) {
		window.localStorage.removeItem(`${process.env.VUE_APP_IDENTIFIER}_${key}`);
	} else {
		window.localStorage.setItem(`${process.env.VUE_APP_IDENTIFIER}_${key}`, value);
	}
}

export const load = (key, fallback) => {
	return window.localStorage.getItem(`${process.env.VUE_APP_IDENTIFIER}_${key}`, fallback);
}


export const throttle = (fn, threshold = 500, context) => {
	let timer;

	return function () {
		if (timer) clearTimeout(timer);
		timer = setTimeout(fn.bind(context), threshold);
	};
};

function hankana2Zenkana(str) {
	var kanaMap = {
		'ｶﾞ': 'ガ', 'ｷﾞ': 'ギ', 'ｸﾞ': 'グ', 'ｹﾞ': 'ゲ', 'ｺﾞ': 'ゴ',
		'ｻﾞ': 'ザ', 'ｼﾞ': 'ジ', 'ｽﾞ': 'ズ', 'ｾﾞ': 'ゼ', 'ｿﾞ': 'ゾ',
		'ﾀﾞ': 'ダ', 'ﾁﾞ': 'ヂ', 'ﾂﾞ': 'ヅ', 'ﾃﾞ': 'デ', 'ﾄﾞ': 'ド',
		'ﾊﾞ': 'バ', 'ﾋﾞ': 'ビ', 'ﾌﾞ': 'ブ', 'ﾍﾞ': 'ベ', 'ﾎﾞ': 'ボ',
		'ﾊﾟ': 'パ', 'ﾋﾟ': 'ピ', 'ﾌﾟ': 'プ', 'ﾍﾟ': 'ペ', 'ﾎﾟ': 'ポ',
		'ｳﾞ': 'ヴ', 'ﾜﾞ': 'ヷ', 'ｦﾞ': 'ヺ',
		'ｱ': 'ア', 'ｲ': 'イ', 'ｳ': 'ウ', 'ｴ': 'エ', 'ｵ': 'オ',
		'ｶ': 'カ', 'ｷ': 'キ', 'ｸ': 'ク', 'ｹ': 'ケ', 'ｺ': 'コ',
		'ｻ': 'サ', 'ｼ': 'シ', 'ｽ': 'ス', 'ｾ': 'セ', 'ｿ': 'ソ',
		'ﾀ': 'タ', 'ﾁ': 'チ', 'ﾂ': 'ツ', 'ﾃ': 'テ', 'ﾄ': 'ト',
		'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ',
		'ﾊ': 'ハ', 'ﾋ': 'ヒ', 'ﾌ': 'フ', 'ﾍ': 'ヘ', 'ﾎ': 'ホ',
		'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ',
		'ﾔ': 'ヤ', 'ﾕ': 'ユ', 'ﾖ': 'ヨ',
		'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ',
		'ﾜ': 'ワ', 'ｦ': 'ヲ', 'ﾝ': 'ン',
		'ｧ': 'ァ', 'ｨ': 'ィ', 'ｩ': 'ゥ', 'ｪ': 'ェ', 'ｫ': 'ォ',
		'ｯ': 'ッ', 'ｬ': 'ャ', 'ｭ': 'ュ', 'ｮ': 'ョ',
		'｡': '。', '､': '、', 'ｰ': 'ー', '｢': '「', '｣': '」', '･': '・'
	};

	const reg = new RegExp('(' + Object.keys(kanaMap).join('|') + ')', 'g');
	return str
		.replace(reg, function (match) {
			return kanaMap[match];
		})
		.replace(/ﾞ/g, '゛')
		.replace(/ﾟ/g, '゜');
}

export const formatUserInput = text => {
	if (!text) return text;

	// 全角转半角
	text = text.replace(/[Ａ-Ｚａ-ｚ０-９]/g, m => String.fromCharCode(m.charCodeAt(0) - 0xfee0));
	// 半角カタ转全角
	text = hankana2Zenkana(text);
	if (/^(?:\d{1,3}\s?)?\d{2,3}-\d{4}-\d{4}$/[Symbol.match](text)) {
		text = text.replace(/-/g, '');
	}
	return text;
}

export default {
	sleep,
	getTimeDiff,
	getDateString,
	waitUntil,
	logX,
	save,
	load,
	formatUserInput,
	parseJSON
};